import templateUrl from './service-area-add.html';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import clone from 'lodash/clone';
import size from 'lodash/size';

export const serviceAreaAddComponent = {
    bindings: {
        resolve: '<',
        close: '&'
    },

    templateUrl,

    controller: class ServiceAreaAddComponent {
        constructor(ServiceAreaCountyService, toastr, GoogleLocationService) {
            'ngInject';

            this.toastr = toastr;
            this.serviceAreaCountyService = ServiceAreaCountyService;
            this.googleLocationService = GoogleLocationService;
        }

        $onInit() {
            this.serviceAreaDetails = {};
            this.disableSaveButton = true;
            this.isServiceAreaFieldHaveError = false;
            this.isLocationDisabled = false;
            this.selectedServiceAreaType = '';
            this.selectedServiceAreaName = '';
        }

        /*******************
         * Public Methods
         ***************/

        getLocationDetails(locationDetails) {
            this.serviceAreaDetails = clone(locationDetails);
            this.serviceAreaTypeOptions = this._getServiceAreaTypeOptions(locationDetails);
            this._validateServiceArea();
        }

        _validateServiceArea() {
            if (this.serviceAreaDetails.lat && this.serviceAreaDetails.lng) {
                this.isServiceAreaFieldHaveError = size(this.serviceAreaTypeOptions) > 0 ? false : true;
            } else {
                this.isServiceAreaFieldHaveError = false;
            }
        }

        onChangeServiceAreaType({ id: type }) {
            this.disableSaveButton = false;
            this.selectedServiceAreaType = type;
            this.selectedServiceAreaName = this._getServiceAreaTypeName(type);
        }

        onSubmit() {
            this.disableSaveButton = true;
            if (this.serviceAreaDetails && size(this.serviceAreaDetails.serviceAreas) > 0) {
                this.selectedServiceAreaName = this._getFormattedServiceAreaNameIfItsCounty();
                this._addServiceAreaCounty();
                this.close();
            } else {
                this.isLocationDisabled = false;
                this.isServiceAreaFieldHaveError = true;
                this.disableSaveButton = false;
            }
        }


        /******************* 
         * Private methods
        ***************/

        _addServiceAreaCounty() {
            this._getLatlngDetailsByPlaceName(this.selectedServiceAreaName)
                .then(details => this.serviceAreaCountyService.addServiceAreaCounty(details))
                .then(_ => this.toastr.success(`${this.selectedServiceAreaName} added successfully.`))
                .then(_ => this.resolve.details.reloadCountyList())
                .catch(err => this.toastr.error(err));
        }

        _getFormattedServiceAreaNameIfItsCounty() {
            return this.selectedServiceAreaType === 'county' ? this._removeCountyWordFromServiceAreaCounty(this.selectedServiceAreaName) : this.selectedServiceAreaName;
        }

        _getLatlngDetailsByPlaceName(serviceAreaName) {
            const placeName = this._getFormattedPlaceName(serviceAreaName);

            return this.googleLocationService.getLocationDetailsByPlaceName(placeName)
                .then(([details]) => {
                    const { geometry: { location: { lat, lng } } } = details;

                    return {
                        name: this.selectedServiceAreaName,
                        type: this.selectedServiceAreaType,
                        latlng: {
                            lat: lat(),
                            lng: lng()
                        },
                        stateCode: this._getInitialsByType('state')
                    };
                })
                .catch(err => {
                    this.isServiceAreaFieldHaveError = true
                    throw err;
                });
        }

        _getFormattedPlaceName(serviceAreaName) {
            const countryInitial = this._getInitialsByType('country');
            const stateInitial = this._getInitialsByType('state');

            const serviceAreas = this._getReverseOrderOfServiceTypeOptions();
            const index = this._getIndexOfSelectedServiceArea(serviceAreas, serviceAreaName);
            const areas = serviceAreas.splice(index);

            let placeName = _getPlaceName();

            function _getPlaceName() {
                return areas.map(({ value }) => value);
            }

            return `${placeName.join(',')},${stateInitial},${countryInitial}`;
        }

        _getIndexOfSelectedServiceArea(serviceAreas, serviceAreaName) {
            return findIndex(serviceAreas, { value: serviceAreaName });
        }

        _getReverseOrderOfServiceTypeOptions() {
            const options = clone(this.serviceAreaTypeOptions);
            return options.reverse();
        }

        _getServiceAreaTypeName(type) {
            return find(this.serviceAreaTypeOptions, { id: type }).value;
        }

        _getInitialsByType(type) {
            return find(this.serviceAreaDetails.serviceAreas, { type }).name;
        }

        _getServiceAreaTypeOptions({ serviceAreas }) {
            return this.serviceAreaCountyService.getServiceAreaTypeOptions(serviceAreas);
        }

        _removeCountyWordFromServiceAreaCounty(countyName) {
            return countyName.replace('County', '').trim();
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/service-area/service-area-add/service-area-add.component.js